import { Collection } from "../../models/collection";

export const collections: readonly Collection[] = [
  {
    id: "54294535-36f1-4e24-835a-6877589f1e12",
    title: "House 1",
    musics: [
      {
        id: "e327771e-8461-444b-835a-6877589f1e12",
        thumbnail:
          "https://i.scdn.co/image/ab67616d0000b27326c15ffd59c51744a14f3831",
        title: "SPRINTER",
        collection: "House 1",
        artists: ["KARMA"],
        source: "/musics/karma__sprinter.mp3",
      },
      {
        id: "58c1f555-b0f6-4889-bf3a-5ca74913ea21",
        thumbnail: "https://i1.sndcdn.com/artworks-4PyCiuIwchOV-0-t500x500.jpg",
        title: "State Your Name",
        collection: "House 1",
        artists: ["Starjunk 95"],
        source: "/musics/starjunk95__state-your-name.mp3",
      },
      {
        id: "649863b1-689f-4930-835a-6877589f1e12",
        thumbnail:
          "https://i1.sndcdn.com/artworks-viFBchLPRnotNyjj-1Xuoyw-t500x500.jpg",
        title: "Back 2 Back",
        collection: "House 1",
        artists: ["Inlie"],
        source: "/musics/inlie__back-2-back.mp3",
      },
      {
        id: "491059c0-5348-44f7-b6d7-5d3dbd0df8b8",
        thumbnail:
          "https://i1.sndcdn.com/artworks-WORvNChuNHDr6MVM-iSBLsA-t500x500.jpg",
        title: "Groove District",
        collection: "House 1",
        artists: ["Starjunk 95"],
        source: "/musics/starjunk95__groove-district.mp3",
      },
      {
        id: "1053051c-2467-421c-835a-6877589f1e12",
        thumbnail:
          "https://i1.sndcdn.com/artworks-v4VkXRnoMyxNDJb8-D3MLkA-t500x500.png",
        title: "Im Ballin",
        collection: "House 1",
        artists: ["Yere"],
        source: "/musics/yere__im-ballin.mp3",
      },
      {
        id: "9ac7ba3e-9458-497c-b015-0bda80354148",
        thumbnail:
          "https://i1.sndcdn.com/artworks-8LIwSYyhw9lghYEk-2USFsQ-t500x500.jpg",
        title: "Stardust Circuit",
        collection: "House 1",
        artists: ["Starjunk 95"],
        source: "/musics/starjunk95__stardust-circuit.mp3",
      },
      {
        id: "4730451d-9502-485f-835a-6877589f1e12",
        thumbnail:
          "https://i1.sndcdn.com/artworks-uWco5Zrb8sqzIlpH-KyJHUQ-t240x240.jpg",
        title: "Every Night",
        collection: "House 1",
        artists: ["CHRONOSONDER"],
        source: "/musics/chronosonder__every-night.mp3",
      },
    ],
  },
];
